import {Marketer} from '../models/marketer.model';

/**
 * Pre-fill values for the edit-marketer form.
 *
 * MUST read the camelCase model fields (`fullName`/`phoneNumber`). Reading the
 * non-existent snake_case `full_name`/`phone_number` opens the form blank and
 * overwrites the real name/phone on save (dashboard #4).
 */
export function buildInitialMarketerFormValues (marketer: Marketer): {
  fullName: string;
  email: string;
  phoneNumber: string;
} {
  return {
    fullName: marketer.fullName || '',
    email: marketer.email || '',
    phoneNumber: marketer.phoneNumber || ''
  };
}
